import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingRecipes = function () { return utilBalancing.getBalancing().Recipes; };
export var selectBalancingRecipe = memoize(function (recipeId) {
    return selectBalancingRecipes().get(recipeId);
});
export var balancingRecipesMemoizedFunctions = [selectBalancingRecipes, selectBalancingRecipe];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingRecipes.ts
// module id = 323
// module chunks = 3